module.exports = __webpack_public_path__ + "static/media/Balenciaga-Red-Knife-Bootie-Lyst_thumb.af1ed301.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Balenciaga-Red-Knife-Bootie-Lyst_thumb.png
// module id = 272
// module chunks = 0